'use client';

import { NextErrorProps } from '~/types/next-error-props';

const GlobalError = ({ error, reset }: NextErrorProps) => (
  <html>
    <body>
      <div className="globalError">
        <div className="errorHandled">
          <h2>Something went wrong!</h2>

          <p>An error occurred.</p>

          <p>
            Please report this error if the problem persists.
            {error.digest ? ` Reference digest: ${error.digest}` : null}
          </p>

          <div className="buttonRow">
            <button
              onClick={() => reset()}
              type="button"
            >
              Try again
            </button>

            <button
              // eslint-disable-next-line no-return-assign
              onClick={() => (location.href = '/')}
              type="button"
            >
              Go to home
            </button>
          </div>
        </div>
      </div>
    </body>
  </html>
);

export default GlobalError;
